export const ANTI_DISCRIMINATION_POLICY = {
  id: 'anti-discrimination-policy',
  title: 'Anti-Discrimination Policy',
  version: 'v1.0-2026-05-17',
  effectiveDate: '17/05/2026',
  audience: 'all',
  content: `ANTI-DISCRIMINATION POLICY — RESERVO

Status: DRAFT — pending solicitor review

1. PURPOSE

This policy sets out Reservo's prohibition on discrimination and harassment in the provision of the Reservo platform and the obligations of Drivers, Riders, and Reservo personnel under Australian and NSW anti-discrimination law.

2. LEGAL FRAMEWORK

2.1 This policy aligns with:
  (a) Racial Discrimination Act 1975 (Cth);
  (b) Sex Discrimination Act 1984 (Cth);
  (c) Disability Discrimination Act 1992 (Cth);
  (d) Age Discrimination Act 2004 (Cth);
  (e) Australian Human Rights Commission Act 1986 (Cth);
  (f) Anti-Discrimination Act 1977 (NSW);
  (g) Point to Point Transport (Taxis and Hire Vehicles) Act 2016 (NSW).

3. PROTECTED ATTRIBUTES

3.1 Discrimination, harassment, or vilification on the basis of any of the following attributes is prohibited:
  (a) race, colour, descent, national or ethnic origin;
  (b) sex, gender identity, intersex status;
  (c) sexual orientation;
  (d) marital or relationship status;
  (e) pregnancy or potential pregnancy, breastfeeding;
  (f) family or carer responsibilities;
  (g) disability (physical, sensory, intellectual, psychiatric, learning);
  (h) age;
  (i) religion or absence of religion;
  (j) political opinion;
  (k) trade union membership;
  (l) social origin;
  (m) HIV / AIDS status;
  (n) homelessness or housing status;
  (o) source of income (including welfare or disability support payments);
  (p) appearance (including tattoos, piercings, traditional dress).

4. PROHIBITED CONDUCT

4.1 Direct discrimination — treating a person less favourably on the basis of a protected attribute.

4.2 Indirect discrimination — imposing a rule or condition that disadvantages people with a protected attribute and that is not reasonable in the circumstances.

4.3 Harassment — unwelcome conduct on the basis of a protected attribute that creates a hostile, intimidating, or offensive environment.

4.4 Vilification — public conduct that incites hatred, serious contempt, or severe ridicule of a person or group on the basis of a protected attribute.

4.5 Victimisation — treating someone unfavourably because they have made or supported a discrimination complaint.

5. DRIVER OBLIGATIONS

5.1 Drivers must NOT:
  (a) refuse a booking on the basis of a protected attribute;
  (b) cancel an accepted booking after seeing the Rider's name, photo, or behaviour, where cancellation is motivated by a protected attribute;
  (c) charge differential fees on the basis of a protected attribute;
  (d) use demeaning, racist, sexist, homophobic, transphobic, ableist, or other discriminatory language;
  (e) refuse to carry assistance animals (see Accessibility Policy);
  (f) refuse to transport a passenger because of their dress, appearance, accent, or perceived background;
  (g) make unwanted personal comments on a passenger's appearance, religion, race, sexuality, or other protected attribute;
  (h) physically segregate or refuse normal courtesy to a passenger on the basis of a protected attribute.

5.2 Drivers MUST:
  (a) treat every passenger with courtesy and equal respect;
  (b) accept lawful bookings without discriminating;
  (c) communicate professionally and in plain language;
  (d) report any incident of discriminatory conduct they witness or experience to Reservo.

6. RIDER OBLIGATIONS

6.1 Riders must NOT discriminate against, harass, or vilify their Driver on the basis of a protected attribute.

6.2 Discriminatory conduct by a Rider may result in account suspension or termination.

7. RESERVO OPERATIONS OBLIGATIONS

7.1 Reservo will NOT:
  (a) base any operational decision (matching, ratings, payouts, eligibility) on a protected attribute;
  (b) tolerate discriminatory conduct by Drivers, Riders, or its own personnel;
  (c) retaliate against any person making a discrimination complaint in good faith.

7.2 Reservo will:
  (a) include anti-discrimination training in mandatory Driver onboarding and annual refresher modules;
  (b) investigate every discrimination complaint promptly and impartially;
  (c) take proportionate action against substantiated discrimination, up to and including immediate suspension or termination;
  (d) cooperate with anti-discrimination authorities.

8. COMPLAINTS

8.1 Anyone who has experienced or witnessed discrimination on the Reservo platform may submit a complaint through:
  (a) the in-app complaints feature;
  (b) admin@reservo.au;
  (c) the Australian Human Rights Commission (humanrights.gov.au, 1300 656 419);
  (d) the NSW Anti-Discrimination Board (antidiscrimination.justice.nsw.gov.au, 1800 670 812);
  (e) the NSW Point to Point Transport Commissioner for transport-service matters.

8.2 Reservo acknowledges discrimination complaints within 24 hours and aims to provide an initial substantive response within 7 days and resolution within 28 days, with serious matters escalated immediately.

9. CONSEQUENCES OF BREACH

9.1 Substantiated discrimination by a Driver may result in:
  (a) written warning;
  (b) mandatory retraining;
  (c) temporary suspension;
  (d) permanent termination of Driver status;
  (e) referral to anti-discrimination authorities;
  (f) referral to the NSW Point to Point Transport Commissioner;
  (g) civil claims by the affected person.

9.2 Substantiated discrimination by a Rider may result in account suspension or termination.

10. REVIEW

10.1 This policy is reviewed annually and after any substantiated discrimination complaint.

---
VERSION HISTORY
v1.0 — 17/05/2026 — Initial draft for solicitor review.

---
THIS DOCUMENT IS A DRAFT FOR PRE-LAUNCH REVIEW.`,
};